export default "__VITE_ASSET__C9M5Y0kk__"